import React from 'react';
import ReactDOM from 'react-dom';
import { store } from 'srs.sharedcomponents/lib/esm/redux/store';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import { injectStore } from 'srs.sharedcomponents/lib/esm/api/agent';
import Spinner from 'srs.sharedcomponents/lib/esm/components/Spinner';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { env } from 'srs.sharedcomponents/lib/esm/api/env';
import ThemeWrapper from 'srs.sharedcomponents/lib/esm/components/molecules/ThemeWrapper/ThemeWrapper';
import { ThemeProvider } from 'srs.sharedcomponents/lib/esm/components/context/themeContext';
import { BrowserRouter as Router } from 'react-router-dom';
import { customTheme } from './styles/theme';
import { componentsConfig } from './components/config';
import { ComponentsProvider } from 'srs.sharedcomponents/lib/esm/components/context/componentsContext';
import { ConfigProvider } from 'srs.sharedcomponents/lib/esm/components/context/appConfig';
import AppWrapper from './AppWrapper';
import { globalStyles } from './styles/global';
import RouterProvider from 'srs.sharedcomponents/lib/esm/components/context/router/RouterProvider';
import { appConfig } from './config/app.config';
import routesConfig from './components/config/routes';
import './css/main.css';
import { HelmetProvider } from 'react-helmet-async';

globalStyles();
injectStore(store);
const persistor = persistStore(store);

let hadToken = !!store.getState().user?.user?.token;
store.subscribe(() => {
    const hasToken = !!store.getState().user?.user?.token;
    if (hadToken && !hasToken) {
        void persistor.flush();
    }
    hadToken = hasToken;
});

const initApplicationInsights = () => {
    return new ApplicationInsights({
        config: {
            connectionString: env.APPLICATIONINSIGHTS_CONNECTION_STRING,
            /* ...Other Configuration Options... */
        },
    });
};

const appInsights = initApplicationInsights();

if (env.APPLICATIONINSIGHTS_CONNECTION_STRING) {
    appInsights.loadAppInsights();
    appInsights.trackPageView(); // Manually call trackPageView to establish the current user/session/pageview
}

ReactDOM.render(
    <React.StrictMode>
        <ConfigProvider appConfig={appConfig}>
            <Provider store={store}>
                <ComponentsProvider componentsConfig={componentsConfig}>
                    <ThemeProvider>
                        <ThemeWrapper theme={customTheme}>
                            <PersistGate
                                loading={<Spinner />}
                                persistor={persistor}
                            >
                                <Router>
                                    <RouterProvider routesConfig={routesConfig}>
                                        <HelmetProvider>
                                            <AppWrapper
                                                appInsights={appInsights}
                                            />
                                        </HelmetProvider>
                                    </RouterProvider>
                                </Router>
                            </PersistGate>
                        </ThemeWrapper>
                    </ThemeProvider>
                </ComponentsProvider>
            </Provider>
        </ConfigProvider>
    </React.StrictMode>,
    document.getElementById('root')
);
